<script setup lang="ts">
import { useDesignConfirm } from '#design-tokenomics/composables/useDesignConfirm'
import { Button } from '@forgd/ui-kit/button'
import { Dialog, DialogContent } from '@forgd/ui-kit/dialog'
import { ExclamationCircleIcon } from '@heroicons/vue/24/outline'

const { state, answer } = useDesignConfirm()
</script>

<template>
  <Dialog data-el="DtConfirmModal" :open="state.isOpen" @update:open="(open) => !open && answer(false)">
    <DialogContent @interact-outside="(event) => event.preventDefault()">
      <div data-testid="dt-confirm" class="flex flex-col gap-2.5">
        <ExclamationCircleIcon class="size-10 shrink-0 text-accent" aria-hidden="true" />
        <div class="flex flex-col justify-center gap-2.5">
          <span class="text-xl font-semibold text-primal">
            {{ state.title }}
          </span>
          <span v-if="state.description" class="text-sm text-gray-600">
            {{ state.description }}
          </span>
        </div>
        <div class="mt-2.5 flex items-center gap-4">
          <Button
            variant="outline"
            class="flex-1"
            data-testid="dt-confirm-cancel"
            @click="answer(false)"
          >
            {{ state.cancelLabel || 'Cancel' }}
          </Button>
          <Button
            class="flex-1"
            data-testid="dt-confirm-proceed"
            @click="answer(true)"
          >
            {{ state.confirmLabel || 'Yes, Continue' }}
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
</template>
